import { styled } from '@mui/system';
import { useState } from 'react';
import { SketchPicker } from 'react-color';
import { connectField } from 'uniforms';

const ColorDiv = styled('div')({
  width: '36px',
  height: '14px',
  borderRadius: '1px',
});

const SwatchDiv = styled('div')({
  padding: '5px',
  background: '#fff',
  borderRadius: '1px',
  boxShadow: '0 0 0 1px rgba(0,0,0,.2)',
  display: 'inline-block',
  cursor: 'pointer',
});

const PopoverDiv = styled('div')({
  position: 'absolute',
  bottom: 20,
  zIndex: '2',
});

const CoverDiv = styled('div')({
  position: 'fixed',
  top: '0px',
  right: '0px',
  bottom: '-300px',
  left: '0px',
});

export const ColorPickerField = connectField(
  ({ value, onChange, label }: any) => {
    const [Color, setColor] = useState(value);
    const [displayColorPicker, setDisplayColorPicker] = useState(false);

    const handleClick = () => {
      setDisplayColorPicker(!displayColorPicker);
    };

    const handleClose = () => {
      setDisplayColorPicker(false);
    };

    function handleChange(color: any) {
      let colorCss = `rgba(${color.rgb.r},${color.rgb.g},${color.rgb.b},${color.rgb.a})`;
      onChange(colorCss);
      setColor(color.rgb);
    }
    return (
      <div className="flex-center-align" style={{ marginTop: 10 }}>
        <label htmlFor="textAlignSelect">{label}</label>
        <div style={{ marginLeft: 5, paddingTop: 5 }}>
          <SwatchDiv onClick={handleClick}>
            <ColorDiv style={{ background: value }} />
          </SwatchDiv>
          {displayColorPicker ? (
            <PopoverDiv>
              <CoverDiv onClick={handleClose} />
              <SketchPicker color={Color} onChange={handleChange} />
            </PopoverDiv>
          ) : null}
        </div>
      </div>
    );
  }
);
